import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { formatCurrency } from '../../helper/order_helper';
import { computeOrderSummaryDisplay } from '../../helper/order_summary_helper';

export default function OrderDetailSummaryCard({ order }) {
  const summary = computeOrderSummaryDisplay(order);

  return (
    <>
      <h6 className="mb-3 fw-bold">
        <i className="ri-bill-line me-1" />
        Order Summary
      </h6>
      <Card className="border">
        <CardBody className="p-3">
          <div className="d-flex justify-content-between mb-2 gap-2">
            <span className="text-muted">{summary.subtotalLabel}:</span>
            <span className="text-end">
              <strong>{formatCurrency(summary.subtotalAmount)}</strong>
            </span>
          </div>
          {summary.discountAmount > 0 ? (
            <div className="d-flex justify-content-between mb-2 gap-2">
              <span className="text-success">
                <i className="ri-discount-percent-line me-1" />
                Discount:
              </span>
              <span className="text-success text-end">
                <strong>-{formatCurrency(summary.discountAmount)}</strong>
              </span>
            </div>
          ) : null}
          {summary.couponDiscount > 0 ? (
            <div className="d-flex justify-content-between mb-2 gap-2">
              <span className="text-success">
                <i className="ri-coupon-line me-1" />
                Coupon discount:
              </span>
              <span className="text-success text-end">
                <strong>-{formatCurrency(summary.couponDiscount)}</strong>
              </span>
            </div>
          ) : null}
          <div className="d-flex justify-content-between mb-2 gap-2">
            <span className="text-muted">Shipping Fee:</span>
            <span className="text-end">
              <strong>{formatCurrency(summary.shippingFee)}</strong>
            </span>
          </div>
          <hr className="my-2" />
          <div className="d-flex justify-content-between gap-2">
            <span className="fw-bold">Total:</span>
            <span className="fw-bold order-amount text-end">
              {formatCurrency(summary.total)}
            </span>
          </div>
          {order?.razorpayOrderId ? (
            <div className="mt-2 p-2 bg-light rounded">
              <small className="text-muted d-block">Razorpay Order ID:</small>
              <small style={{ wordBreak: 'break-all' }}>{order.razorpayOrderId}</small>
            </div>
          ) : null}
        </CardBody>
      </Card>
    </>
  );
}
